import { render, staticRenderFns } from "./SeventyPercentModal.vue?vue&type=template&id=364cf8a8"
import script from "./SeventyPercentModal.vue?vue&type=script&lang=js"
export * from "./SeventyPercentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports